// extracted by mini-css-extract-plugin
var _1 = "AgreementTemplateStyles-module__action-wrapper___GxPUh";
var _2 = "AgreementTemplateStyles-module__action-wrapper___GxPUh";
var _3 = "AgreementTemplateStyles-module__agreement___oyYTD";
var _4 = "AgreementTemplateStyles-module__agreement-option___LF2Hi";
var _5 = "AgreementTemplateStyles-module__agreement-option___LF2Hi";
var _6 = "AgreementTemplateStyles-module__cancel-btn___Ku4lW";
var _7 = "AgreementTemplateStyles-module__cancel-btn___Ku4lW";
var _8 = "AgreementTemplateStyles-module__checkbox___RZkSj";
var _9 = "AgreementTemplateStyles-module__description___C8Q_v";
var _a = "AgreementTemplateStyles-module__root___EY_VK";
var _b = "AgreementTemplateStyles-module__title___bahVq";
export { _1 as "action-wrapper", _2 as "actionWrapper", _3 as "agreement", _4 as "agreement-option", _5 as "agreementOption", _6 as "cancel-btn", _7 as "cancelBtn", _8 as "checkbox", _9 as "description", _a as "root", _b as "title" }
